export default {
    Email: 'E-mail',
    ConfirmEmail: 'Confirm E-mail',
    Password: 'Password',
    Verificationcode: 'Verification code',
    AlreadyhaveaHitPawaccountLogin: 'Already have a HitPaw account ? Login',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy1:
        'By proceeding, you agree to our Services of Use and Privacy Policy',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy2:
        'By proceeding, you agree to our Services of Use and Privacy Policy',
    Byproceedingyouagreetoour: 'By proceeding, you agree to our ',
    ServicesofUse: 'Services of Use',
    and: ' and ',
    PrivacyPolicy: 'Privacy Policy',
    last: '.',
    TheEmailformatisincorrect: 'The E-mail format is incorrect',
    Pleaseenterthesameemailinbothfields: 'Please enter the same email in both fields.',
    Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter:
        'The password must be 8-50 characters and contain at least two categories among the following: number, letter or special character.',
    Incorrectverificationcode: 'Incorrect verification code',
    ThisEmailhasbeenregisteredpleasechooseanother:
        'This E-mail has been registered, please choose another.',
    Cannotbeemptyhere: 'Cannot be empty here.',
    Rememberme: 'Remember me',
    ForgotPassword1: 'Forgot Password?',
    NotaregistereduseryetSignUp: 'Not a registered user yet? Sign Up',
    Notaregistereduseryet1: 'Not a registered user yet? ',
    Notaregistereduseryet2: 'Sign Up',
    NoaccountfoundwiththatEmailaddress: 'No account found with that E-mail address',
    YourEmailaddressorpasswordwasincorrectPleasetryagain:
        'Your E-mail address or password was incorrect. Please try again.',
    ForgotPassword2: 'Forgot Password',
    GetVerificationCode: 'Get Verification Code',
    VerifyEmail: 'Verify E-mail',
    Ithasbeensenttoyourmailboxpleasecheckit:
        'It has been sent to your mailbox , please check it',
    PleaseinputEmailaddress: 'Please input E-mail address',
    TheEmailisnotregistered: 'The E-mail is not registered',
    Invalidverificationcodepleasereenterthecorrectone:
        'Invalid verification code, please re-enter the correct one',
    Resetpassword: 'Reset password',
    Emailaddressverificationsucceeded: 'E-mail address verification succeeded',
    Pleaseresetyourpassword: 'Please reset your password',
    Enteranewpassword: 'Enter a new password',
    Confirm: 'Confirm',
    Newpasswordshouldbe850characterslongcomposedoflettersornumbersoramixtureoflettersnumbers:
        'New password should be 8-50 characters long, composed of letters or numbers or a mixture of letters + numbers',
    Passwordresetsuccessfully: 'Password reset successfully',
    Name: 'Name',
    GetCode: 'Get Code',
    Loginsuccessful: 'Login successful',
    Loginfailed: 'Login failed',
    Signupsuccessful: 'Sign up successful',
    Signupfailed: 'Sign up failed',
    Getpassword: 'Get password',
    Authorizationhasexpiredpleaseloginagain: 'Authorization has expired, please log in again.',
    Sorrysomethingwentwrongpleasetryagainlater:
        'Sorry, something went wrong, please try again later.',
    Toomanysamerequestsweremadeinashortperiodoftimepleasetryagainlater:
        'Too many same requests were made in a short period of time, please try again later.',
    Couldntfindyouraccountorthepasswordisincorrect:
        "Couldn't find your account, or the password is incorrect.",
    Youaretryingtoaccessapaidfunctionpleasesubscribefirst:
        'You are trying to access a paid function, please subscribe first.',
    Accessdeniedfortheunauthorizedrequest: 'Access denied for the unauthorized request.',
    Alreadyhaveaccount: 'Already have account?',
    SignUpwithemail: 'Sign Up with email',
    Securityverification: 'Security verification',
    Pleaseenterthecorrectemailaddress: 'Please enter the correct email address!',
    PleaseInputverificationCode: 'Please Input verification code!',
    Pleaseenterthesamepasswordinbothfields: 'Please enter the same password in both fields!',
    or: 'Or',
    ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword:
        'The new password you entered is the same as your old password. Enter a different password',
    YourpasswordwasincorrectPleasetryagain: 'Your password was incorrect. Please try again.',
    reg400: 'Sorry, something went wrong, please try again later.',
    reg400223: 'The email and code is not match ,please check',
    reg400224: 'Token is expired',
    500: 'Server side error!',
    Afewsecondsaway: 'Login or register in seconds',
    ContinuewithGoogle: 'Continue with Google',
    ContinuewithEmail: 'Continue with Email',
    LoginwithEmail: 'Log in with Email',
    Usemorethan8charactersandmixlettersnumbersandsymbols:
        'Use more than 8 characters with mix letters, numbers and symbols (supporting symbols:@$!%*#_~?&^)',
    ConfirmPassword: 'Confirm Password',
    Pleaseloginwithemail: 'Please log in with Email',
    youraccount: 'Your account',
    alreadyexiststoensurethesecuritypleaseverifyitfirst:
        'already exists, to ensure the security of your account, please complete the verification first.',
    Login: 'Login',
    exceed6Times: 'Your trial has run out today,please upgrade to Pro to access all premium features.',
    exceed20M: "The file size for free accounts cannot exceed 20MB,please upgrade to Pro to access all premium features."
}